/**
 * Placeholder security & audit data. Replace with the audit-log API: event
 * stream, security alerts, per-user activity and the login-activity series.
 */

export const SECURITY_STATS = [
  {
    key: "total",
    label: "Total Audit Events",
    value: "58,742",
    foot: "All time",
    tone: "blue",
    icon: "shield",
  },
  {
    key: "month",
    label: "Events (This Month)",
    value: "8,924",
    delta: "12.6%",
    foot: "vs last month",
    tone: "green",
    icon: "check",
  },
  {
    key: "alerts",
    label: "Security Alerts (This Month)",
    value: "27",
    delta: "28.6%",
    deltaTone: "warn",
    foot: "vs last month",
    tone: "amber",
    icon: "alert",
  },
  {
    key: "failed",
    label: "Failed Login Attempts",
    value: "134",
    delta: "9.8%",
    deltaTone: "warn",
    foot: "vs last month",
    tone: "indigo",
    icon: "users",
  },
  {
    key: "sessions",
    label: "Active Sessions",
    value: "42",
    foot: "Currently online",
    tone: "sky",
    icon: "session",
  },
];

export const MODULES = [
  "NIF Registration",
  "Taxpayer",
  "Data Quality",
  "Authentication",
  "Reports",
  "Data Integration",
];

export const ACTIONS = [
  "CREATE",
  "UPDATE",
  "APPROVE",
  "DELETE",
  "LOGIN",
  "EXPORT",
  "IMPORT",
  "LOGIN_FAILED",
];

export const USERS = [
  "John Doe",
  "Jane Smith",
  "Maria Fernandes",
  "Carlos Alberto",
  "System",
  "Ana Pereira",
  "Joao Manuel",
  "Bruno Costa",
];

export const TOTAL_EVENTS = 58742;

export const AUDIT_LOGS = [
  {
    id: 1,
    date: "01 Sep 2026",
    time: "10:30:45 AM",
    user: "John Doe",
    action: "CREATE",
    module: "NIF Registration",
    details: "Created NIF application #APP-2026-000125",
    ip: "192.168.1.45",
    status: "Success",
  },
  {
    id: 2,
    date: "01 Sep 2026",
    time: "10:28:12 AM",
    user: "Jane Smith",
    action: "UPDATE",
    module: "Taxpayer",
    details: "Updated taxpayer profile - NIF 5001234567",
    ip: "192.168.1.18",
    status: "Success",
  },
  {
    id: 3,
    date: "01 Sep 2026",
    time: "10:20:33 AM",
    user: "Maria Fernandes",
    action: "APPROVE",
    module: "NIF Registration",
    details: "Approved NIF application #APP-2026-000124",
    ip: "192.168.1.22",
    status: "Success",
  },
  {
    id: 4,
    date: "01 Sep 2026",
    time: "10:15:09 AM",
    user: "Carlos Alberto",
    action: "DELETE",
    module: "Data Quality",
    details: "Deleted duplicate record set #DUP-8891",
    ip: "192.168.1.33",
    status: "Success",
  },
  {
    id: 5,
    date: "01 Sep 2026",
    time: "10:10:22 AM",
    user: "System",
    action: "LOGIN",
    module: "Authentication",
    details: "User login successful",
    ip: "192.168.1.45",
    status: "Success",
  },
  {
    id: 6,
    date: "01 Sep 2026",
    time: "10:08:51 AM",
    user: "Ana Pereira",
    action: "EXPORT",
    module: "Reports",
    details: "Exported report: Taxpayer Summary Report",
    ip: "192.168.1.27",
    status: "Success",
  },
  {
    id: 7,
    date: "01 Sep 2026",
    time: "09:58:17 AM",
    user: "Joao Manuel",
    action: "IMPORT",
    module: "Data Integration",
    details: "Imported file: Taxpayer_Master_2026-09-01.xlsx",
    ip: "192.168.1.19",
    status: "Success",
  },
  {
    id: 8,
    date: "01 Sep 2026",
    time: "09:45:30 AM",
    user: "Bruno Costa",
    action: "LOGIN_FAILED",
    module: "Authentication",
    details: "Failed login attempt",
    ip: "203.0.113.56",
    status: "Failed",
  },
];

/**
 * Severity colours reuse the app's status palette; validated for adjacent-pair
 * separation in this order, and every band is labelled in the legend.
 */
export const TOTAL_ALERTS = 27;

export const SEVERITY_BREAKDOWN = [
  {
    label: "High Severity",
    value: 7,
    share: 25.9,
    color: "#df3f45",
    legendPrimary: "7",
    legendSecondary: "(25.9%)",
  },
  {
    label: "Medium Severity",
    value: 12,
    share: 44.4,
    color: "#ef9c17",
    legendPrimary: "12",
    legendSecondary: "(44.4%)",
  },
  {
    label: "Low Severity",
    value: 6,
    share: 22.2,
    color: "#1b6fd6",
    legendPrimary: "6",
    legendSecondary: "(22.2%)",
  },
  {
    label: "Informational",
    value: 2,
    share: 7.4,
    color: "#26a269",
    legendPrimary: "2",
    legendSecondary: "(7.4%)",
  },
];

export const TOP_USERS = [
  { user: "John Doe", events: "2,145", share: "24.0%" },
  { user: "Jane Smith", events: "1,732", share: "19.4%" },
  { user: "Maria Fernandes", events: "1,298", share: "14.5%" },
  { user: "Carlos Alberto", events: "1,012", share: "11.3%" },
  { user: "Ana Pereira", events: "985", share: "11.0%" },
];

export const SECURITY_EVENTS = [
  {
    id: 1,
    date: "01 Sep 2026",
    time: "10:15:09 AM",
    type: "Multiple Failed Logins",
    severity: "High",
    user: "Unknown",
    description: "5 failed login attempts detected",
    ip: "203.0.113.56",
    status: "Open",
  },
  {
    id: 2,
    date: "01 Sep 2026",
    time: "09:58:17 AM",
    type: "Unusual Data Export",
    severity: "Medium",
    user: "Ana Pereira",
    description: "Large data export (25,430 records)",
    ip: "192.168.1.27",
    status: "Investigating",
  },
  {
    id: 3,
    date: "01 Sep 2026",
    time: "09:45:30 AM",
    type: "Permission Change",
    severity: "Medium",
    user: "John Doe",
    description: "User roles updated",
    ip: "192.168.1.45",
    status: "Closed",
  },
  {
    id: 4,
    date: "01 Sep 2026",
    time: "09:20:14 AM",
    type: "Consecutive Login Failures",
    severity: "Low",
    user: "Unknown",
    description: "3 consecutive failed logins",
    ip: "198.51.100.23",
    status: "Closed",
  },
  {
    id: 5,
    date: "31 Aug 2026",
    time: "04:10:11 PM",
    type: "Password Reset",
    severity: "Informational",
    user: "Maria Fernandes",
    description: "Password reset successful",
    ip: "192.168.1.22",
    status: "Closed",
  },
];

export const LOGIN_DAYS = [
  "26 Aug",
  "27 Aug",
  "28 Aug",
  "29 Aug",
  "30 Aug",
  "31 Aug",
  "01 Sep",
];

export const LOGIN_SERIES = [
  {
    key: "success",
    label: "Successful Logins",
    color: "#26a269",
    values: [142, 156, 149, 168, 161, 178, 176],
  },
  {
    key: "failed",
    label: "Failed Logins",
    color: "#df3f45",
    values: [18, 24, 16, 21, 15, 26, 19],
  },
];

export const LOGIN_MAX = 200;

export const SECURITY_ACTIONS = [
  {
    key: "audit",
    title: "View Audit Log",
    text: "Search and review system audit logs.",
    icon: "log",
  },
  {
    key: "alerts",
    title: "View Security Alerts",
    text: "Review and manage security alerts.",
    icon: "alert",
  },
  {
    key: "access",
    title: "User Access Review",
    text: "Review user permissions and access.",
    icon: "users",
  },
  {
    key: "sessions",
    title: "Login Sessions",
    text: "View active user sessions.",
    icon: "session",
  },
  {
    key: "settings",
    title: "Audit Log Settings",
    text: "Configure audit log retention and rules.",
    icon: "settings",
  },
];
